<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
        <p class="h3">Töpsch Immobilien</p>

        <ul class="list-unstyled contact-list">
          <li>
            <span>Adresse:</span>
            {{ company.street }}<br />
            <span></span> {{ company.zip }} {{ company.city }}
          </li>

          <li>
            <span>Telefon:</span>
            <a :href="'tel:' + company.phone">
                {{ company.phone }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <p class="h3">Ihr Weg zu uns</p>

        <p class="">
          Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns!
        </p>

        <p>
          <a :href="'https://www.google.de/maps?daddr=' + company.street + ', ' + company.zip + '+' + company.city + '&saddr='"
            title="Route jetzt berechnen"
            target="_blank"
            class="link--arrow">
              Route berechnen
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
